import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'

class IntroBox extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        return (
            <Modal
            {...this.props}
            id="message-box"
            aria-labelledby="contained-modal-title-vcenter"
            className="modal-message"
            >
              <Modal.Header>
                <img onClick={this.props.onHide} className="img-fluid" src="/assets/banners/BW_SA_Jackpots_DesktopPopupBanner.jpg" alt="Banner"/>
              </Modal.Header>
              <Modal.Body className="p-0 my-4">
              <h1 className="text-center">Available Tickets: {this.props.balance}</h1>


              </Modal.Body>

            </Modal>
        );
    }
}


export default IntroBox;



// WEBPACK FOOTER //
// ./components/MessageBox/intro.js